module.exports = __webpack_public_path__ + "img/g-trash.4f47f6d1.svg";